import { useAppSettings } from '../../../../../../../common/config';

type Props = {
  pricingDate?: string | null;
  settlementAgentCmgEntityKey?: string | null;
};

// Only offerings with a pricing date after this date will be restricted.
// This allows the buy side to see allocations for offerings prior to this restriction going into effect.
const PRICING_DATE_CUTOFF = '2025-07-31';

export const useIsBuySideRestrictedFromSeeingAllocation = ({
  pricingDate,
  settlementAgentCmgEntityKey,
}: Props): boolean => {
  const appSettings = useAppSettings();
  const allocationBuySideDisabledBannerForAuthorEntities =
    appSettings.allocationBuySideDisabledBannerForAuthorEntities;

  if (!pricingDate || !settlementAgentCmgEntityKey) {
    return false;
  }

  // check if the pricing date is after the cut-off date. both are in ISO 8601 format (YYYY-MM-DD)
  const isAfterCutOff = new Date(pricingDate) > new Date(PRICING_DATE_CUTOFF);

  const settlmentAgentMatches = allocationBuySideDisabledBannerForAuthorEntities.includes(
    settlementAgentCmgEntityKey
  );

  return isAfterCutOff && settlmentAgentMatches;
};
